import z from "zod";

export const featureRequestsValidator = z.object({
  featureId: z.number().optional(),
  isActive: z.boolean().optional(),
  me: z.boolean().optional(),
});
